export default function getResource(label, vars = []) {
    const resources = {
        modalTitle: 'Apply Points to Your Purchase',
        modalSubTitle: `You currently have <b>${vars[0]}</b> points`,
        chooseText: 'Please choose one:',
        biCashAmount: `<b>${vars[0]}</b> Beauty Insider Cash`,
        pointsAmount: `${vars[0]} points`,
        apply: 'Apply',
        applied: 'Applied',
        remove: 'Remove',
        subtotal: 'Order Subtotal',
        pointsAppliedLegal: 'Points applied for Beauty Insider Cash are non-refundable.',
        done: 'Done',
        emptyBasketError: 'Merchandise, excluding gift cards, must be included in your order to qualify for this offer.',
        biCashSubtotalError: 'Your applied points cannot exceed the eligible order subtotal. To apply points to your purchase please make sure your eligible order subtotal is greater than the value of points you want to apply.'
    };

    return resources[label];
}
